export const LOGIN_KEYS = {
  token: "loyalty_admin.token",
  user: "loyalty_admin.user",
  tenant: "loyalty_admin.tenant",
  appConfig: "loyalty_admin.app_config_by_tenant",
};

const LEGACY_APP_CONFIG_KEY = "loyalty_admin.app_config";

const readJson = (key) => {
  const json = localStorage.getItem(key);
  try {
    return JSON.parse(json);
  } catch (e) {
    return null;
  }
};

export const saveLogin = (token, user, tenant) => {
  localStorage.setItem(LOGIN_KEYS.token, token);
  localStorage.setItem(LOGIN_KEYS.user, JSON.stringify(user));
  localStorage.setItem(LOGIN_KEYS.tenant, JSON.stringify(tenant));
};

export const getToken = () => {
  return localStorage.getItem(LOGIN_KEYS.token);
};

export const getUser = () => {
  return readJson(LOGIN_KEYS.user);
};

export const getTenant = () => {
  return readJson(LOGIN_KEYS.tenant);
};

export const getTenantCode = () => {
  return getTenant()?.code ?? null;
};

export const saveAppConfig = (tenantCode, appConfig) => {
  if (!tenantCode || appConfig?.tenant?.code !== tenantCode) {
    return;
  }

  const configs = readJson(LOGIN_KEYS.appConfig) ?? {};
  configs[tenantCode] = appConfig;
  localStorage.setItem(LOGIN_KEYS.appConfig, JSON.stringify(configs));
  localStorage.removeItem(LEGACY_APP_CONFIG_KEY);
};

export const getAppConfig = (tenantCode) => {
  localStorage.removeItem(LEGACY_APP_CONFIG_KEY);

  if (!tenantCode) {
    return null;
  }

  const appConfig = readJson(LOGIN_KEYS.appConfig)?.[tenantCode] ?? null;
  return appConfig?.tenant?.code === tenantCode ? appConfig : null;
};

export const clearLogin = () => {
  Object.values(LOGIN_KEYS).forEach((key) => localStorage.removeItem(key));
  localStorage.removeItem(LEGACY_APP_CONFIG_KEY);
};
